import React from 'react';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { connect } from 'react-redux';
import UserRole from '../../shared/model/UserRole';
import RemoveCard from '../components/RemoveCard';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';

class RemoveScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES_PAPER_BIN,
            Breadcrumbs.MY_OUTSOURCES_PAPER_BIN_REMOVE,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    renderError() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_ELIMINAR_RECURSOS_DE_MIS_SUBCONTRATAS')} breadcrumbs={breadcrumbs}>
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{I18nUtils.tr('TR_NO_TIENES_PERMISOS_PARA_ELIMINAR')}</h3>
                </section>
            </PsPage>
        );
    }

    render() {
        const { user } = this.props;
        const noRole = !user || !user.roles || !user.roles[0];

        if ( noRole ) return null;

        const roleId = user.roles[0].role.id;

        switch ( roleId ) {
            case UserRole.SUPERADMIN:
            case UserRole.ADMIN:
                return this.renderContent();
            case UserRole.OUTSOURCES_MANAGER:
            case UserRole.OUTSOURCES_VIEWER:
            case UserRole.CONTRACTORS_MANAGER:
                return this.renderError();
            default:
        }
    }

    renderContent() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_ELIMINAR_RECURSOS_DE_MIS_SUBCONTRATAS')} breadcrumbs={breadcrumbs}>
                <RemoveCard/>
            </PsPage>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.auth.user,
    };
};

export default connect(mapStateToProps)(RemoveScreen);



// WEBPACK FOOTER //
// ./src/app/remove/screens/RemoveScreen.js